import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbSeparator, BreadcrumbPage } from "@/components/ui/breadcrumb";
import AdminPanelLayout from "./admin-panel/admin-panel-layout";
import { ContentLayout } from "./admin-panel/content-layout";
import { ReactNode } from "react";
import { useLocation } from "react-router-dom";

interface BreadcrumbLayoutProps {
    homeLink: string;
    children?: ReactNode;
}

interface RouteTitles {
    [key: string]: { breadcrumbPage: string; contentTitle: string };
}

const routeTitles: RouteTitles = {
    "/": { breadcrumbPage: "Accueil", contentTitle: "Accueil" },
    "/dashboard": { breadcrumbPage: "Tableau de bord", contentTitle: "Tableau de bord" },
    "/parrainage": { breadcrumbPage: "Parrainage", contentTitle: "Parrainage" },
    "/affiliate-withdraw": { breadcrumbPage: "Retrait", contentTitle: "Retrait" },
};

export const AppLayout = ({ homeLink, children }: BreadcrumbLayoutProps) => {
    const location = useLocation();

    const { breadcrumbPage, contentTitle } = routeTitles[location.pathname] || {
        breadcrumbPage: "",
        contentTitle: "",
    };

    return (
        <AdminPanelLayout>
            <ContentLayout title={contentTitle}>
                <Breadcrumb>
                    <BreadcrumbList>
                        <BreadcrumbItem>
                            <BreadcrumbLink asChild>
                                <a href={homeLink}>{breadcrumbPage}</a>
                            </BreadcrumbLink>
                        </BreadcrumbItem>
                        <BreadcrumbSeparator />
                        <BreadcrumbItem>
                            <BreadcrumbPage>{contentTitle}</BreadcrumbPage>
                        </BreadcrumbItem>
                    </BreadcrumbList>
                </Breadcrumb>
                {children}
            </ContentLayout>
        </AdminPanelLayout>

    );
};